import React, { useState } from 'react'
import { Select, Space } from 'antd';
import styled from 'styled-components';


const { Option } = Select;

function SelectMultipleWithSearch(props) {
    const [searchValue, setSearchValue] = useState('');

    const handleSearch = (value) => {
        setSearchValue(value);
    };

    const handleSelect = (value) => {
        if (props.mode) {
           
            if (value.includes("ALL") || value.includes("all")) {
                props.setFieldValue(props.name, ["all"]); // Force only "ALL" selection
            } else {
                props.setFieldValue(
                    props.name, 
                    value.filter((v) => v !== "ALL" && v !== "all") // Remove "ALL" if another option is selected
                );
            }
        } else {
            props.setFieldValue(props.name, value);
        }
    };

    const filterOption = (input, option) => {
        const { value, children } = option.props;
        return (
          children.toString().toLowerCase().includes(input.toLowerCase())
        );
      };
  return (
    <SpaceItem wrap gap={props.gap} mr={props.mr} mb={props.mb}>
        <ItemSelect
            showSearch
            mode={props?.mode ? "multiple" : "single"}
            size={props.size ? props.size : "large"}
            placeholder={props.placeholder ?props.placeholder : "Select"}
            style={{
                width: props.width? props.width : 230,
            }}
            onChange={handleSelect}
            onSearch={handleSearch}
            filterOption={filterOption}
            value={props.value}
            bradius={props.bradius}
            // disabled={props.value?.includes("ALL") || props.value?.includes("all")}
        >
            {props.options?.map((i,index)=> 
                <Option key={index} value={i.code}>{i.code}</Option>
            )}   
        </ItemSelect>
        
       
    </SpaceItem>
  )
}

export default SelectMultipleWithSearch

const SpaceItem = styled(Space)`
    position: relative;
    gap: ${({gap})=> gap ? gap : '8px'};
    margin-right: ${({mr})=> mr? mr : "unset"};
    margin-bottom: ${({mb})=> mb? mb : "unset"};
    & .ant-space-item {
        width: 100%;
    }
`
const ItemSelect = styled(Select)`

    & .ant-select-selector {
        border-radius: ${({bradius}) => bradius? bradius : "4px !important;"};
        padding-left: ${({ is_icon })=> is_icon ? "20px !important": 'unset'};
    }
    & .ant-select-selection-placeholder {
        color: #d9d9d9 !important;
        font-size: 16px;
        font-weight: 400;
    }
    & .ant-select-arrow {
        color: #d9d9d9 !important;
    }
`